import NoDeals from '../NoDeals';

import CardDeals from './CardDeals';

import type { CardDealsProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/CardDealsProps';

const CardDealsWrapper = (props: CardDealsProps) => {
  const hasCards = props.cards?.length || props.cardsV2?.length;
  if (!hasCards) {
    if (!props.noDeals) {
      return null;
    }
    return <NoDeals {...props.noDeals} />;
  }
  return <CardDeals {...props} />;
};

export default CardDealsWrapper;
